import { EntityId, createSelector } from '@reduxjs/toolkit';
import { RootState } from '../..';
import memoize from 'lodash/memoize';

export const selectPages = (state: RootState) => state.pages;
export const selectTotalPages = createSelector(selectPages, pages => pages.ids?.length);
export const selectPageById = memoize((id: EntityId) => createSelector(selectPages, pages => pages.entities[id]!));
export const selectPageByIndex = memoize((index: number) =>
    createSelector(selectPages, pages => pages.entities[pages.ids[index - 1]])
);
